export const AUTH_UPDATE = "AUTH_UPDATE";
export const AUTH_RESET = "AUTH_RESET";
